import { render, staticRenderFns } from "./FileDownloadLink.vue?vue&type=template&id=7ab6903a"
import script from "./FileDownloadLink.vue?vue&type=script&lang=ts"
export * from "./FileDownloadLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports